import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'components/consumer/Checkbox';

const markNestedItemsAsFalse = items => {
  if (!items || !items.length) {
    return items;
  }

  return items.map(({ label, items: nestedItems, value }) => ({
    label,
    checked: false,
    value: value || '',
    items:
      nestedItems && nestedItems.length
        ? markNestedItemsAsFalse(nestedItems)
        : nestedItems,
  }));
};

const CheckboxTree = ({ onChange = () => {}, items = [], depth = 0 }) => (
  <div className="CheckboxTree">
    {items.map(
      ({ label, checked = false, items: nestedItems, value }, itemIndex) => (
        <>
          <div className="items-center flex h-[29px]">
            {depth >= 1 && (
              <div
                className="bg-gray-light7 h-px mr-4"
                style={{ width: `${depth === 1 ? 22 : depth * 35}px` }}
              />
            )}

            <Checkbox
              size="sm"
              value={value || ''}
              key={`checkbox-tree-${label}-${depth}`}
              onChange={() => {
                const updatedItems = [...items];
                const updatedChecked = !checked;

                updatedItems[itemIndex] = {
                  label,
                  checked: updatedChecked,
                  value,
                  items:
                    !updatedChecked && nestedItems && nestedItems.length
                      ? markNestedItemsAsFalse(nestedItems)
                      : nestedItems,
                };

                onChange(updatedItems);
              }}
              checked={checked}
            >
              {label}
            </Checkbox>
          </div>

          {!!nestedItems && !!nestedItems.length && checked && (
            <div className="flex">
              {depth === 0 && <div className="bg-gray-light7 my-3.5 w-px" />}

              <CheckboxTree
                key={`checkbox-tree-root-${label}-${depth}`}
                items={nestedItems}
                onChange={updatedNestedItems => {
                  const updatedItems = [...items];
                  updatedItems[itemIndex] = {
                    ...items[itemIndex],
                    items: updatedNestedItems,
                  };

                  onChange(updatedItems);
                }}
                depth={depth + 1}
              />
            </div>
          )}
        </>
      )
    )}
  </div>
);

CheckboxTree.propTypes = {
  depth: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      checked: PropTypes.bool.isRequired,
      items: PropTypes.array,
    })
  ).isRequired,
};

export default CheckboxTree;
